import { oc } from '@orpc/contract';
import { listScenariosInputSchema, listScenariosOutputSchema } from '../schemas/scenarios.schemas.js';
export const listScenariosContract = oc
    .route({
    method: 'GET',
    path: '/scenarios',
    tags: ['Scenarios'],
    summary: 'List test scenarios with filters, sorting and pagination',
})
    .input(listScenariosInputSchema)
    .output(listScenariosOutputSchema);
//# sourceMappingURL=list-scenarios.contract.js.map